/**
 * Button that exports dose-calculator history as a CSV download.
 */
import { useStockSolutionsHistory } from './useStockSolutionsHistory';

function pad(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

function downloadCsv(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function ExportHistoryButton() {
  const { history, clear, toCSV } = useStockSolutionsHistory();

  const handleExport = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = pad(now.getMonth() + 1);
    const dd = pad(now.getDate());
    const csv = toCSV();
    downloadCsv(csv, `stock-solutions-history-${yyyy}-${mm}-${dd}.csv`);
  };

  const handleClear = () => {
    if (window.confirm('Clear all dose history?')) {
      clear();
    }
  };

  const isEmpty = history.length === 0;

  return (
    <div className="mt-4 space-y-2">
      <button
        type="button"
        disabled={isEmpty}
        onClick={handleExport}
        className={`w-full font-semibold py-2.5 px-4 rounded-lg transition-colors ${
          isEmpty
            ? 'bg-slate-700 text-slate-500 cursor-not-allowed'
            : 'bg-cyan-600 text-white hover:bg-cyan-700'
        }`}
      >
        Export History (CSV)
      </button>
      {!isEmpty && (
        <button
          type="button"
          onClick={handleClear}
          className="block w-full text-xs text-slate-400 hover:text-red-400 transition-colors text-center"
        >
          Clear history
        </button>
      )}
    </div>
  );
}
